module.exports="query Obligations($client: String!, $accountId: ID!) {\n  obligations(lookupBy: { client: $client, ids: [$accountId]}) {\n    visitId\n  }\n}"